import { render, staticRenderFns } from "./LicensedGoods.vue?vue&type=template&id=649e7e47&scoped=true&"
import script from "./LicensedGoods.vue?vue&type=script&lang=js&"
export * from "./LicensedGoods.vue?vue&type=script&lang=js&"
import style0 from "./LicensedGoods.vue?vue&type=style&index=0&id=649e7e47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649e7e47",
  null
  
)

component.options.__file = "LicensedGoods.vue"
export default component.exports